import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('color', {
    hex: {
        title: 'Hex',
        type: 'string'
    }
});
var validator = z.object({
    _type: z.literal('color'),
    hex: z.string().optional()
});
schema.color;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=color.js.map